import { render, staticRenderFns } from "./CartRoomInfo.vue?vue&type=template&id=b184e88c"
import script from "./CartRoomInfo.vue?vue&type=script&lang=js"
export * from "./CartRoomInfo.vue?vue&type=script&lang=js"
import style0 from "./CartRoomInfo.vue?vue&type=style&index=0&id=b184e88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports